import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import ConfigApi from '../../../../configs/ConfigApi';
import PageProperties from '../../../models/PageProperties';
import PickCategoryByPageId from '../../../models/PickCategoryByPageId';
import CategoryPlaceholder from '../../../placeholders/CategoryPlaceholder';
import AxiosAuth from '../../../utils/AxiosAuth';
import { setActiveMenu } from '../../../utils/Menu';
import CategorySection01 from '../section/CategorySection01';
import DefaultSidebarSection from '../section/DefaultSidebarSection';

function CategoryPageControl({ pageId }) {
    const dispatch = useDispatch();
    const [articleData, setArticleData] = useState(null);
    const page = `category-online/${pageId}`;

    useEffect(() => {
        AxiosAuth.post(ConfigApi.PAGE_REQUIREMENT, {
            require: {
                recent: 5,

                'category-online/sports': 5,
                'category-online/entertainment': 5,
                'category-online/jobs': 5,
                [page]: 20,
            },
        }).then(({ data }) => {
            setArticleData(data.articles);
        });
    }, [page]);

    useEffect(() => {
        dispatch(setActiveMenu(pageId));
    }, [dispatch, pageId]);

    PageProperties(PickCategoryByPageId('online', pageId).title);

    if (articleData === null) {
        return <CategoryPlaceholder />;
    }

    return (
        <div className="container">
            <div className="row mt-4">
                <CategorySection01
                    category="online"
                    pageId={pageId}
                    articles={articleData[page]}
                    latestArticles={articleData.recent}
                />

                <DefaultSidebarSection
                    latestArticles={articleData.recent}
                    articles1={articleData['category-online/sports']}
                    title1="খেলা"
                    articles2={articleData['category-online/entertainment']}
                    title2="বিনোদন"
                    articles3={articleData['category-online/jobs']}
                    title3="চাকরি"
                />
            </div>
        </div>
    );
}

export default function CategoryPage() {
    const { pageId } = useParams();

    return <CategoryPageControl key={pageId} pageId={pageId} />;
}
